import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import {
  IJopPostInputs,
  TIndustry,
} from '../../../../../interfaces/jobpost.interface';
import { capitalizeAndAddColon } from '../../../../../utils/capitalizeAndAddColon';
import FlexibleMultiSelect from './FlexibleMultiSelect';

export type ISelectItems = TIndustry[];

interface IJobPostFilterMultiSelect {
  control?: Control<IJopPostInputs, any>;
  validationRules?: RegisterOptions<IJopPostInputs>;
  name?: keyof IJopPostInputs;
  label: string;
  selectItems: ISelectItems;
  placeholder: string;
  value?: string[];
  onChange?: (value: string[]) => void;
  helperText?: string;
  error?: boolean;
}

const JobPostFilterMultiSelect: React.FC<IJobPostFilterMultiSelect> = ({
  name,
  selectItems = [],
  label,
  placeholder,
  validationRules,
  control,
  value,
  onChange,
  helperText,
  error,
}) => {
  if (control && !name) {
    throw Error('name prop is required when use form control');
  }

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <Typography
        variant="body4"
        sx={{
          padding: '0 2px',
        }}
      >
        {capitalizeAndAddColon(label)}
      </Typography>

      <FormControl error={error} sx={{ width: '100%' }}>
        {/* stand alone */}
        {!control && (
          <FlexibleMultiSelect
            label={label}
            value={value}
            onChange={onChange}
            selectItems={selectItems}
            placeholder={placeholder}
            helperText={helperText}
          />
        )}

        {/* part of form */}
        {control && name && (
          <Controller
            name={name}
            control={control}
            rules={validationRules}
            defaultValue={[]}
            render={({ field }) => (
              <FlexibleMultiSelect
                label={label}
                field={field}
                selectItems={selectItems}
                placeholder={placeholder}
                helperText={helperText}
              />
            )}
          />
        )}
      </FormControl>
    </Box>
  );
};

export default JobPostFilterMultiSelect;
